export const inputPhoneFrame = {
    title: {
        type: "Veuillez choisir un type de téléphone",
        flag: "Veuillez choisir un indicatif international"
    }
}